module.exports = __webpack_public_path__ + "img/mailouts-mailbox-success.a111f0cd.svg";